"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveI18nSetting = exports.SaveI18nSetting = exports.SaveI18nSettingActionTypes = exports.stageLocale = exports.stageLanguage = exports.loadI18nSetting = exports.FetchI18nSetting = exports.FetchI18nSettingActionTypes = exports.loadI18nOptions = exports.FetchI18nOptions = exports.FetchI18nOptionsActionTypes = exports.I18nActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var _actions = require("settings-ui-sdk/utils/actions");

var _actions2 = require("settings-ui-lib/utils/actions");

var I18nActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_I18N_OPTIONS: null,
  FETCH_I18N_SETTING: null,
  STAGE_LANGUAGE: null,
  STAGE_LOCALE: null,
  SAVE_I18N_SETTING: null
}, 'accountdefaults');
exports.I18nActionTypes = I18nActionTypes;
var FetchI18nOptionsActionTypes = (0, _actions.createRequestTypes)(I18nActionTypes.FETCH_I18N_OPTIONS);
exports.FetchI18nOptionsActionTypes = FetchI18nOptionsActionTypes;
var FetchI18nOptions = (0, _actions.createRequestActions)(FetchI18nOptionsActionTypes);
exports.FetchI18nOptions = FetchI18nOptions;
var loadI18nOptions = (0, _createAction.default)(I18nActionTypes.FETCH_I18N_OPTIONS);
exports.loadI18nOptions = loadI18nOptions;
var FetchI18nSettingActionTypes = (0, _actions.createRequestTypes)(I18nActionTypes.FETCH_I18N_SETTING);
exports.FetchI18nSettingActionTypes = FetchI18nSettingActionTypes;
var FetchI18nSetting = (0, _actions.createRequestActions)(FetchI18nSettingActionTypes);
exports.FetchI18nSetting = FetchI18nSetting;
var loadI18nSetting = (0, _createAction.default)(I18nActionTypes.FETCH_I18N_SETTING);
exports.loadI18nSetting = loadI18nSetting;
var stageLanguage = (0, _createAction.default)(I18nActionTypes.STAGE_LANGUAGE, (0, _actions2.mapPayloadTo)('language'));
exports.stageLanguage = stageLanguage;
var stageLocale = (0, _createAction.default)(I18nActionTypes.STAGE_LOCALE, (0, _actions2.mapPayloadTo)('locale'));
exports.stageLocale = stageLocale;
var SaveI18nSettingActionTypes = (0, _actions.createRequestTypes)(I18nActionTypes.SAVE_I18N_SETTING);
exports.SaveI18nSettingActionTypes = SaveI18nSettingActionTypes;
var SaveI18nSetting = (0, _actions.createRequestActions)(SaveI18nSettingActionTypes);
exports.SaveI18nSetting = SaveI18nSetting;
var saveI18nSetting = (0, _createAction.default)(I18nActionTypes.SAVE_I18N_SETTING, (0, _actions2.mapPayloadTo)('language', 'locale'));
exports.saveI18nSetting = saveI18nSetting;